<template>
    <div class="xeGoalUsageChart heightMAX" :class="{ 'is-overview-compact': isOverviewCompact }">
        <!-- #4da8ef" -->
        <div class="kbet-custom-reset heightMAX">
            <div class="rounded kbet-widget-energy heightMAX" :style="{ display: 'block' }">
                <!-- :style="{background: this.widget.chart.backgroundColor, display: 'block'}" -->
                <!-- #2D353CFF 검 / #ffffffff 백-->

                <div class="title rounded-top d-flex justify-content-between align-items-center">
                    <span>{{ $t(widget.title) }}</span>
                    <div class="safari-style-buttons">
                        <label class="safari-button red">
                            <input type="radio" value="DAYBYMONTH" v-model="viewMode" />
                            <span class="button-dot"></span>
                        </label>
                        <label class="safari-button yellow">
                            <input type="radio" value="MONTHBYYEAR" v-model="viewMode" />
                            <span class="button-dot"></span>
                        </label>
                        <label class="safari-button green">
                            <input type="radio" value="ANALYSIS" v-model="viewMode" />
                            <span class="button-dot"></span>
                        </label>
                    </div>
                </div>

                <!-- 분석 모드일 때의  레이아웃 -->
                <xe-goal-before-analysis v-if="viewMode === 'ANALYSIS'" :data="newChartData" :cardSize="cardSize" />

                <!-- 기존 모드일 때의 레이아웃 -->
                <div v-else class="d-flex flex-row heightMAX energy-usage-area"
                    :style="isOverviewCompact
                        ? { padding: '0 8px', height: 'calc(100% - 28px)' }
                        : { padding: '0px 20px', height: 'calc(100% - 41px)' }">
                    <div class="goal-card-container" :class="isOverviewCompact ? 'col-4' : 'col-5'">
                        <!-- 통합 카드 -->
                        <div class="goal-card" :style="{ borderTopColor: getGoalStatusColor(predictAchievement) }">
                            <div class="card-title">목표 대비</div>
                            <div class="card-value" :class="getGoalStatusClass(predictAchievement)">
                                <div class="dropping-texts">
                                    <div class="percentage-text">
                                        {{ getGoalStatusValue(predictAchievement) }}%
                                        <span class="goal-status-text">{{ getGoalStatusText(predictAchievement) }}
                                            예상</span>
                                    </div>
                                    <div class="usage-text">
                                        {{ formatValue(totDiffPredictUsage, 0) }} {{
                                            baseUnit.text === "-" ? "" : baseUnit.text }}&nbsp;
                                        {{ getGoalStatusText(predictAchievement) }} 예상
                                    </div>
                                </div>
                            </div>

                            <!-- 목표, 예상, 현재 정보 -->
                            <div class="card-info">
                                <div class="info-row">
                                    <div class="info-label">
                                        <div class="legend-color" :style="{ backgroundColor: usageColors.goal }"></div>
                                        목표:
                                    </div>
                                    <div class="info-value">{{ formatValue(this.totGoalUsage().toFixed(2)) }}</div>
                                </div>
                                <div class="info-row">
                                    <div class="info-label">
                                        <div class="legend-color" :style="{ backgroundColor: usageColors.predict }">
                                        </div>
                                        예상:
                                    </div>
                                    <div class="info-value">{{ formatValue(this.totPredictUsage().toFixed(2)) }}
                                    </div>
                                </div>
                                <div class="info-row">
                                    <div class="info-label">
                                        <div class="legend-color" :style="{ backgroundColor: usageColors.current }">
                                        </div>
                                        현재:
                                    </div>
                                    <div class="info-value">{{ formatValue(this.totNowUsage().toFixed(2))
                                    }} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div :class="isOverviewCompact ? 'col-8' : 'col-7'" class="d-flex flex-column" :style="{ height: '100%' }">
                        <div class="goal-chart-title">{{ getGoalChartTitle }}</div>
                        <div ref="waterfallChart" style="width: 100%; height: 85%"></div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="modalSetting" size="lg" :title="`${$t('설정')} - ${$t('목표대비 에너지 사용량')}`" body-class="p-t-0 p-b-0"
            hide-footer @shown="onGoalUsageSettingModal(true)" @hidden="onGoalUsageSettingModal(false)">
            <xe-goal-usage-setting :modalShow="goalUsageSettingModal" :initSetting="goalUsageSetting"
                @on-modal-cancel="onModalCancel" @on-modal-ok="onModalOK" />
        </b-modal>
    </div>
</template>

<script>
import xeBaseWidget from "@src/views/widget/v1/common/xeBaseWidget.js";
import * as echarts from "echarts";
import xeGoalUsageSetting from "./setting/xeGoalUsageSetting.vue";
import xeGoalBeforeAnalysis from "./xeGoalBeforeAnalysis.vue";

export default {
    name: "xeGoalUsageChart",
    extends: xeBaseWidget,
    props: ["cardHeight", "cardWidth"],
    components: {
        xeGoalUsageSetting,
        xeGoalBeforeAnalysis,
    },
    data() {
        return {
            chart: null,
            newChartData: {},
            goalUsageSettingModal: false,
            // ECharts 데이터
            xAxisLabel: [],
            originalDates: [], // 원본 날짜 데이터 저장
            baseDataName: "",
            accData: [], // 누적량
            goalDataName: "",
            goalData: null,
            predictData: null,
            unitMap: {},
            findTargetHeader: null,
            baseUnit: "",
            goalBoundaryColor: {
                safe: "#43A047",
                normal: "#424242",
                over: "#E53935",
            },
            // 목표, 예상, 현재 색깔 설정
            usageColors: {
                goal: "#757575", // 목표 색깔
                predict: "#d32f2f", // 예상 색깔
                current: "#5470c6", // 현재 색깔
                title: "#909090", // 제목 색깔
            },
            viewMode: this.widget.timeDsvn || "DAYBYMONTH",
        };
    },
    watch: {
        viewMode(newVal) {
            this.initChart();
            this.widget.timeDsvn = newVal;
            this.fetchChartData();
        },
        cardSize() {
            this.chart.resize();
            this.updateChartVisibility();
        },
    },
    computed: {
        getGoalChartTitle() {
            if (this.newChartData.values?.regDt?.length === 0) {
                return "";
            }
            const date = this.newChartData.values?.regDt?.[0];
            if (!date) {
                return "";
            }
            const dateParts = date.split("-");
            const year = parseInt(dateParts[0], 10);
            const month = parseInt(dateParts[1], 10);

            if (this.viewMode === "DAYBYMONTH") {
                // "월간 목표분석 (YYYY-MM)" 형식으로 변환
                return `월간 목표분석 (${year}년 ${month}월)`;
            } else if (this.viewMode === "MONTHBYYEAR") {
                return `연간 목표분석 (${year}년도)`;
            }
            return "";
        },
        cardSize() {
            return this.cardHeight * this.cardWidth;
        },
        goalUsageSetting() {
            return JSON.parse(JSON.stringify(this.widget));
        },
        master() {
            return this.$store.getters.master;
        },
        predictAchievement() {
            if (this.isFalsy(this.totGoalUsage()) || this.isFalsy(this.totPredictUsage())) {
                return 0;
            }

            return ((this.totPredictUsage() / this.totGoalUsage()) * 100).toFixed(0);
        },
        totDiffPredictUsage() {
            return this.totPredictUsage() - this.totGoalUsage();
        },
    },
    created() {
        if (!this.widget.bgIcon) {
            this.widget.bgIcon = "material timeline";
        }
        if (!this.widget.addition) {
            this.widget.addition = {
                afterAction: "",
                fixed: 0,
            };
        }
        if (!this.widget.self) {
            this.widget.self = {
                baseline: { type: this.searchBoxCond.type, sTi: "", eTi: "" },
                compare: { type: this.searchBoxCond.type, sTi: "", eTi: "" },
            };
        }
        if (!this.widget.chart) {
            this.widget.chart = {
                colorOpens: false,
                // backgroundColor: "#474F6CFF",3F3F3FFF
                backgroundColor: "#3F3F3FFF",
                gridColor: "#E1E1E133",
                fontColor: "#FFFFFFFF",

                series: [
                    {
                        type: "line",
                        label: {
                            enabled: false,
                        },
                        point: "",
                        position: "Left",
                        fill: false,
                        compare: false,
                        dataColor: "#00AAAA",
                    },
                ],
                options: {
                    stacked: true,
                    fill: false,
                    fixed: 0,
                    legend: {
                        display: false,
                        position: "top",
                        align: "flex-end",
                        labels: {
                            boxWidth: 10,
                            fontSize: 14,
                            fontStyle: "normal",
                            fontColor: "#000000",
                        },
                    },
                    yAxes: {

                        left: {
                            display: true,
                            label: "Unit1",
                            min: 0,
                            max: 0,
                            unit: "",
                            fontSize: 12,
                            fontColor: "#000000",
                        },
                        right: {
                            display: true,
                            label: "Unit2",
                            min: 0,
                            max: 0,
                            unit: "",
                            fontSize: 12,
                            fontColor: "#000000",
                        },
                    },
                },
            };
        }
        if (!this.widget.title) {
            this.widget.title = "당월 목표대비 에너지 사용량";
        }
    },
    mounted() {
        let goal = document.getElementsByClassName("xeGoalUsageChart");

        for (let i = 0; i < goal.length; i++) {
            goal[i].parentNode.style.height = "100%";
        }

        // this.fetchChartData(); // 최초 진입 시 데이터 로딩
    },
    // 컴포넌트 제거 시 정리
    beforeDestroy() {
        // 컴포넌트가 제거될 때 차트 인스턴스 정리
        if (this.chart) {
            this.chart.dispose();
            this.chart = null;
        }
        window.removeEventListener("resize", () => {
            this.chart.resize();
        });
    },
    methods: {
        initChart() {
            if (this.chart) {
                this.chart.dispose();
                this.chart = null;
            }
        },
        isFalsy(value) {
            // null, undefined, 빈 문자열, 0, false, NaN 체크
            if (value === null || value === undefined) return true;
            if (value === "") return true;
            if (value === 0) return true;
            if (value === false) return true;
            if (Number.isNaN(value)) return true;

            // 빈 배열 체크
            if (Array.isArray(value) && value.length === 0) return true;

            // 빈 객체 체크 (단, Date 객체는 제외)
            if (typeof value === "object" && !(value instanceof Date)) {
                if (Object.keys(value).length === 0) return true;
            }

            return false;
        },
        calcGoalBoundary(goalValue) {
            let numGoalValue = Number(goalValue);
            if (numGoalValue < 100) {
                return this.goalBoundaryColor.safe; // 절감 (초록)
            } else {
                return this.goalBoundaryColor.over; // 초과 (붉은)
            }
        },
        // 목표 사용량 합계 반환 함수
        totGoalUsage() {
            // 방어 코드 추가: newChartData, values, goalDataName이 유효한지 체크
            if (
                !this.newChartData ||
                !this.newChartData.values ||
                !this.goalDataName ||
                !Array.isArray(this.newChartData.values[this.goalDataName])
            ) {
                return 0;
            }
            return this.newChartData.values[this.goalDataName].reduce(
                (acc, curr) => Number(acc) + Number(curr || 0),
                0
            );
        },
        // predict.regDt 이전까지의 사용량만 합산하는 함수
        totNowUsage() {
            if (
                !this.newChartData ||
                !this.newChartData.values ||
                !this.baseDataName ||
                !Array.isArray(this.newChartData.values[this.baseDataName])
            ) {
                return 0;
            }

            // predict.regDt가 없으면 전체 합산
            if (!this.newChartData.predict || !this.newChartData.predict.regDt) {
                return this.newChartData.values[this.baseDataName].reduce(
                    (acc, curr) => Number(acc) + Number(curr || 0),
                    0
                );
            }

            const predictRegDt = this.newChartData.predict.regDt;
            const regDtArr = this.newChartData.values.regDt;
            const valueArr = this.newChartData.values[this.baseDataName];

            // regDtArr, valueArr 유효성 체크
            if (!Array.isArray(regDtArr) || !Array.isArray(valueArr) || regDtArr.length !== valueArr.length) {
                return 0;
            }

            // regDt가 predict.regDt보다 작은(이전) 값만 합산
            let sum = 0;
            for (let i = 0; i < regDtArr.length; i++) {
                if (regDtArr[i] < predictRegDt) {
                    sum += Number(valueArr[i] || 0);
                }
            }
            return sum;
        },
        totPredictUsage() {
            let usage = 0;
            if (this.newChartData && this.newChartData.accumulate && this.newChartData.accumulate[this.baseDataName]) {
                usage = this.newChartData.accumulate[this.baseDataName].at(-1);
            }

            return Number(usage);
        },

        nowAchievement() {
            return ((this.totNowUsage() / this.totGoalUsage()) * 100).toFixed(0);
        },

        onGoalUsageSettingModal(flag) {
            this.goalUsageSettingModal = flag;
        },

        initSetting() {
            this.isPanelExpand = false;
        },

        newApplyData(data) {
            this.newChartData = data;
            this.prepareChartData();
        },

        prepareChartData() {
            this.predictData = [];
            const currentDate = new Date();

            if (!this.isEmpty(this.newChartData) && !this.isEmpty(this.newChartData.headers)) {
                // 원본 날짜 데이터 저장
                this.originalDates = this.newChartData.values.regDt;

                // x 축 라벨 세팅 - 월간 모드일 때 일자만 표시
                this.xAxisLabel = this.newChartData.values.regDt.map((dateStr) => {
                    if (this.viewMode === "DAYBYMONTH" && dateStr) {
                        // 월간 모드일 때 YYYY-MM-DD 형식에서 DD만 추출
                        const dateParts = dateStr.split("-");
                        if (dateParts.length === 3) {
                            const day = parseInt(dateParts[2], 10); // 앞의 0 제거
                            return `${day}일`; // 일자만 반환
                        }
                    }
                    return dateStr; // 다른 모드이거나 형식이 다르면 원본 반환
                });

                const mainVariable = this.newChartData.headers.find((header) => header.roleType === "Main");
                const findGoalHeader = this.newChartData.headers.find((header) => header.roleType == "Goal");

                if (mainVariable && mainVariable.ptIdx) {
                    // 사용량
                    this.findTargetHeader = this.newChartData.headers.find(
                        (header) => header.ptIdx == mainVariable.ptIdx
                    );

                    if (!this.isEmpty(this.findTargetHeader)) {
                        this.baseDataName = mainVariable.key;
                        this.baseUnit = this.$store.state.units.find(
                            (unit) => unit.value == this.findTargetHeader.unitSmallCode
                        );
                        this.unitMap[this.baseDataName] = this.findTargetHeader.dispUnit
                            ? this.findTargetHeader.dispUnit
                            : this.baseUnit.text;

                        // 누적량
                        if (!this.isEmpty(this.newChartData.accumulate)) {
                            // widget에서 timeDsvn 값 가져오기 (MONTHBYYEAR 또는 DAYBYMONTH)
                            const timeDsvn = this.widget.timeDsvn || "DAYBYMONTH"; // 기본값

                            this.accData = this.newChartData.accumulate[this.findTargetHeader.key].map((acc, index) => {
                                const originalDate = this.originalDates[index];
                                if (this.isDateAfterOrEqual(originalDate, timeDsvn, currentDate)) {
                                    return null; // 현재 시점 이후는 null로 처리
                                }
                                return acc; // 누적량 그대로 사용
                            });
                        } else {
                            this.accData = [];
                        }
                    }

                    // 목표량
                    if (!this.isEmpty(findGoalHeader)) {
                        this.goalData = this.newChartData?.accumulate?.[findGoalHeader.key] ?? [];
                        this.goalDataName = findGoalHeader.key ?? "-";
                        const goalUnit = this.$store.state.units.find(
                            (unit) => unit.value == findGoalHeader.unitSmallCode
                        );
                        this.unitMap[this.goalDataName] = findGoalHeader.dispUnit
                            ? findGoalHeader.dispUnit
                            : goalUnit.text;
                    }

                    // 예측량
                    if (!this.isEmpty(this.newChartData.predict)) {
                        this.predictData = Array(
                            this.newChartData.values.regDt.length - this.newChartData.predict.regDt.length
                        )
                            .fill(null)
                            .concat(this.newChartData.predict[this.findTargetHeader.key]);
                    } else {
                        this.predictData = [];
                    }
                }
            }

            this.renderChart();
        },

        isDateAfterOrEqual(xAxisValue, timeDsvn, currentDate) {
            if (timeDsvn === "DAYBYMONTH") {
                const today = currentDate.toISOString().slice(0, 10);

                return xAxisValue >= today;
            }
            if (timeDsvn === "MONTHBYYEAR") {
                const currentYearMonth = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(
                    2,
                    "0"
                )}`;
                return xAxisValue >= currentYearMonth;
            }
            return false;
        },
        async fetchChartData() {
            this.$emit("on-fetch-chart-data");
        },
        renderChart() {
            if (this.chart) {
                // 기존 차트를 초기화
                this.chart.clear();
            } else if (this.viewMode !== "ANALYSIS") {
                // ECharts 인스턴스 생성
                this.chart = echarts.init(this.$refs.waterfallChart);
            }

            const unitMap = this.unitMap;
            const baseUnit = this.findTargetHeader?.dispUnit ? this.findTargetHeader?.dispUnit : this.baseUnit.text;
            const goalData = this.goalData;
            const predictData = this.predictData;

            const series = [
                {
                    name: this.baseDataName,
                    type: "line",
                    xAxisIndex: 0,
                    yAxisIndex: 0,
                    smooth: 0.4,
                    symbol: "circle", // 심볼 타입을 circle로 설정
                    symbolSize: 4, // 작은 크기로 설정
                    showSymbol: true, // 기본적으로 심볼 숨김
                    data: this.accData.map((value, index) => {
                        // 마지막 유효한 데이터에만 심볼 표시
                        const lastValidIndex = this.accData.findLastIndex((v) => v !== null);
                        return {
                            value: value,
                            symbolSize: index === lastValidIndex ? 9 : 0, // 마지막에만 심볼 표시
                            showSymbol: index === lastValidIndex,
                        };
                    }),
                    itemStyle: {
                        color: this.usageColors.current,
                    },
                    lineStyle: {
                        width: 3,
                    },
                    label: {
                        show: false,
                        position: "top",
                        formatter: (params) => {
                            return this.formatValue(params.data);
                        },
                        fontSize: 10,
                    },
                    markLine: {
                        symbol: ["none", "none"],
                        lineStyle: {
                            color: this.usageColors.current,
                            width: 1,
                            type: "solid",
                        },
                        label: {
                            show: false,
                        },
                        data: [
                            {
                                xAxis: this.xAxisLabel[this.accData.findLastIndex((v) => v !== null)],
                            },
                        ],
                    },
                },
                {
                    type: "effectScatter",
                    coordinateSystem: "cartesian2d",
                    z: 3,
                    rippleEffect: {
                        period: 2,
                        scale: 2.5,
                        brushType: "stroke",
                    },
                    symbolSize: 10,
                    itemStyle: {
                        color: this.usageColors.current,
                    },
                    data: [
                        [
                            this.xAxisLabel[this.accData.findLastIndex((v) => v !== null)],
                            this.accData[this.accData.findLastIndex((v) => v !== null)],
                        ],
                    ],
                    tooltip: {
                        show: false,
                    },
                },
                {
                    name: this.goalDataName,
                    type: "line",
                    xAxisIndex: 0,
                    yAxisIndex: 0,
                    smooth: 0.4,
                    symbol: "circle", // 심볼(점) 숨김
                    symbolSize: 4, // 작은 크기로 설정
                    showSymbol: true, // 기본적으로 심볼 숨김
                    data: this.goalData.map((value, index) => {
                        return {
                            value: value,
                            symbolSize: index === this.goalData.length - 1 ? 9 : 0, // 마지막에만 심볼 표시
                            showSymbol: index === this.goalData.length - 1,
                        };
                    }),
                    itemStyle: {
                        color: this.usageColors.goal,
                    },
                    lineStyle: {
                        type: "dashed",
                        width: 2,
                    },
                    label: {
                        show: false,
                        position: "insideBottom",
                        formatter: (params) => {
                            if (params.dataIndex === goalData.length - 1) {
                                const label = `월간 목표 설정(${baseUnit}) : ${this.formatValue(
                                    goalData[goalData.length - 1]
                                )}`;
                                return label;
                            }
                            return "";
                        },
                        fontSize: this.isOverviewCompact ? 9 : 12,
                        fontWeight: "bold",
                    },
                },
            ];

            if (!this.isEmpty(this.predictData)) {
                series.push({
                    name: "예상 소비량",
                    type: "line",
                    xAxisIndex: 0,
                    yAxisIndex: 0,
                    smooth: 0.4,
                    symbol: "circle",
                    symbolSize: 4,
                    showSymbol: true,
                    data: this.predictData.map((value, index) => {
                        return {
                            value: value,
                            symbolSize: index === this.predictData.length - 1 ? 9 : 0, // 마지막에만 심볼 표시
                            showSymbol: index === this.predictData.length - 1,
                        };
                    }),

                    z: 1,
                    itemStyle: {
                        color: this.usageColors.predict,
                    },
                    lineStyle: {
                        type: "dashed",
                        width: 1,
                    },
                    label: {
                        show: false,
                        position: "insideTop",
                        formatter: (params) => {
                            if (params.dataIndex === predictData.length - 1) {
                                const label = `예상 소비량(${baseUnit}) : ${this.formatValue(
                                    predictData[predictData.length - 1]
                                )}`;
                                return label;
                            }
                            return "";
                        },
                        fontSize: this.isOverviewCompact ? 9 : 12,
                        fontWeight: "bold",
                    },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: this.usageColors.predict },
                            { offset: 1, color: this.usageColors.predict + "00" },
                        ]),
                    },
                });
            }

            const axisFont = this.isOverviewCompact ? 9 : 12;
            const option = {
                grid: [
                    this.isOverviewCompact
                        ? { left: "10%", right: "2%", top: "8%", height: "72%" }
                        : { left: "13%", right: "3%", top: "10%", height: "75%" },
                ],
                tooltip: {
                    trigger: "axis",
                    confine: false, // 툴팁이 차트 영역을 벗 어나도 표시
                    appendToBody: true, // body에 추가하여 다른 요소 위에 표시
                    backgroundColor: "rgba(0,0,0,0.8)",
                    textStyle: {
                        color: "#fff",
                        fontSize: axisFont,
                    },
                    borderWidth: 0, // 테두리 없음
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985",
                        },
                    },
                    formatter: (params) => {
                        let result = `<div style="font-size: ${axisFont}px;">
                                        <div class="mb-3">
                                            <p class="m-0 p-0">${this.getFullDateForTooltip(params[0].axisValue)}</p>`;
                        params.forEach((param) => {
                            result += `<div style="display: flex; justify-content: space-between;">
                                                <div style="margin-right: 20px;">
                                                    ${param.marker}
                                                    <span>
                                                        ${param.seriesName}
                                                        (${unitMap[param.seriesName]
                                    ? unitMap[param.seriesName]
                                    : baseUnit
                                })
                                                    </span>
                                                </div>
                                                <span style="font-weight: bold;">
                                                    ${this.formatValue(param.value)}
                                                </span>
                                        </div>`;
                        });

                        result += `</div></div>`;
                        return result;
                    },
                },
                xAxis: [
                    {
                        type: "category",
                        axisLine: { show: false }, // x축 선 숨김
                        axisTick: { show: false }, // x축 눈금 숨김
                        data: this.xAxisLabel,
                        axisLabel: {
                            align: "center",
                            show: true, // x축 라벨 보이기
                            fontSize: axisFont,
                            color: "#666",
                        },
                        show: this.shouldShowXAxis(),
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        min: 0,
                        axisLabel: {
                            show: false, // y축 라벨 숨기기
                            align: "right",
                            formatter: (value) => {
                                return this.formatValue(value);
                            },
                        },
                    },
                ],
                series: series,
            };
            this.chart && this.chart.setOption(option);

            // 차트 렌더링 후 가시성 업데이트
            this.$nextTick(() => {
                this.updateChartVisibility();
            });

            window.addEventListener("resize", () => {
                this.chart.resize();
                this.updateChartVisibility();
            });
        },

        formatValue(value, toFixedValue) {
            const numTypevalue = Number(value);
            const absValue = Math.abs(numTypevalue);
            const sign = numTypevalue < 0 ? "-" : "";

            if (absValue >= 1e9) {
                if (toFixedValue !== undefined && toFixedValue !== null) {
                    return sign + (absValue / 1e9).toFixed(toFixedValue) + "G";
                } else {
                    return sign + (Number.isInteger(absValue / 1e9) ? absValue / 1e9 + "G" : (absValue / 1e9).toFixed(1) + "G");
                }
            } else if (absValue >= 1e6) {
                if (toFixedValue !== undefined && toFixedValue !== null) {
                    return sign + (absValue / 1e6).toFixed(toFixedValue) + "M";
                } else {
                    return sign + (Number.isInteger(absValue / 1e6) ? absValue / 1e6 + "M" : (absValue / 1e6).toFixed(1) + "M");
                }
            } else if (absValue >= 1e3) {
                if (toFixedValue !== undefined && toFixedValue !== null) {
                    return sign + (absValue / 1e3).toFixed(toFixedValue) + "K";
                } else {
                    return sign + (Number.isInteger(absValue / 1e3) ? absValue / 1e3 + "K" : (absValue / 1e3).toFixed(1) + "K");
                }
            } else {
                if (toFixedValue !== undefined && toFixedValue !== null) {
                    return numTypevalue.toFixed(toFixedValue);
                } else {
                    return Number.isInteger(numTypevalue) ? numTypevalue.toString() : numTypevalue.toFixed(1);
                }
            }
        },

        // x축 표시 여부 결정
        shouldShowXAxis() {
            // cardHeight를 기반으로 x축 표시 여부 결정
            return this.cardHeight > 5;
        },

        // 차트 가시성 업데이트
        updateChartVisibility() {
            if (!this.chart) return;

            const shouldShowXAxis = this.shouldShowXAxis();

            // 현재 옵션 가져오기
            const currentOption = this.chart.getOption();

            // x축 표시 여부 업데이트
            if (currentOption.xAxis && currentOption.xAxis[0]) {
                currentOption.xAxis[0].show = shouldShowXAxis;
                currentOption.xAxis[0].axisLabel.show = shouldShowXAxis;

                // 옵션 적용
                this.chart.setOption(currentOption);
            }
        },

        getGoalStatusColor(achievement) {
            const numAchievement = Number(achievement);
            if (numAchievement < 100) {
                return "#4caf50"; // 절감 (초록)
            } else {
                return "#f44336"; // 초과 (붉은)
            }
        },

        getGoalStatusText(achievement) {
            const numAchievement = Number(achievement);
            if (numAchievement < 100) {
                return "절감";
            } else {
                return "초과";
            }
        },

        getGoalStatusValue(achievement) {
            const numAchievement = Number(achievement);
            if (numAchievement < 100) {
                // 절감: 100%에서 현재값을 뺀 차이
                return (100 - numAchievement).toFixed(0);
            } else {
                // 초과: 현재값에서 100%를 뺀 차이
                return (numAchievement - 100).toFixed(0);
            }
        },

        getGoalStatusClass(achievement) {
            const numAchievement = Number(achievement);
            if (numAchievement < 100) {
                return "success-gradient"; // 절감 (초록색)
            } else {
                return "danger-gradient"; // 초과 (붉은색)
            }
        },

        getFullDateForTooltip(axisValue) {
            // x축 라벨이 일자만 표시된 경우, 원본 날짜 데이터에서 전체 날짜를 찾아 반환
            if (this.viewMode === "DAYBYMONTH" && this.originalDates) {
                const index = this.xAxisLabel.indexOf(axisValue);
                if (index !== -1 && this.originalDates[index]) {
                    return this.originalDates[index];
                }
            }
            return axisValue;
        },
    },
};
</script>

<style scoped>
.goal-chart-title {
    height: 12%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    font-size: 12px;
    font-weight: 500;
    color: #868e96;
    line-height: 11px;
}

.goal-usage-sub {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

.goal-usage-value {
    font-size: 20px;
    font-weight: 600;
}

.goal-usage-title-small {
    font-size: 12px;
    font-weight: 600;
}

.goal-usage-value-small {
    font-size: 12px;
    font-weight: 600;
}

.goal-usage-title {
    font-size: 12px;
    color: #3f3f3f;
    font-weight: 700;
    line-height: 11px;
}

.goal-card {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 16px;
    padding: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
    border-top: 4px solid;
    position: relative;
    overflow: hidden;
    width: 100%;
}

.goal-card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%);
    z-index: 1;
}

.goal-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.card-title {
    font-size: 13px;
    font-weight: 700;
    color: #495057;
    text-align: center;
    margin-bottom: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.card-value {
    font-size: 12px;
    font-weight: 800;
    color: #ffffff !important;
    text-align: center;
    border-radius: 12px;
    margin-bottom: 10px;
    position: relative;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
    border-radius: 16px;
    margin: 0 0 8px 0;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
    overflow: visible;
    position: relative;
    z-index: 10;
    height: 100%;
    min-height: 40px;
}

.card-value.success-gradient {
    background: linear-gradient(135deg, #4caf50 0%, #45a049 25%, #2e7d32 50%, #1b5e20 75%, #0d4f14 100%) !important;
    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
}

.card-value.danger-gradient {
    background: linear-gradient(135deg, #f44336 0%, #e53935 25%, #d32f2f 50%, #c62828 75%, #b71c1c 100%) !important;
    box-shadow: 0 4px 15px rgba(244, 67, 54, 0.4);
}

.card-info {
    display: flex;
    flex-direction: column;
    padding: 6px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.info-row:last-child {
    border-bottom: none;
}

.info-label {
    font-size: 11px;
    font-weight: 600;
    color: #6c757d;
    flex: 1;
    text-align: left;
    letter-spacing: 0.3px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.info-value {
    font-size: 11px;
    font-weight: 700;
    color: #6c757d;
    flex: 1;
    text-align: right;
    letter-spacing: 0.3px;
}

.goal-status-text {
    font-weight: 600;
    position: relative;
    z-index: 15;
}

.goal-card-container {
    align-self: center;
    text-align: center;
    width: 100%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.legend-color {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    flex-shrink: 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    margin-right: 6px;
}

.dropping-texts {
    display: inline-block;
    width: 100%;
    text-align: center;
    height: 100%;
    vertical-align: -2px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.dropping-texts>div {
    font-size: inherit;
    opacity: 0;
    position: absolute;
    font-weight: 700;
    width: 100%;
    text-align: center;
    /* top: 50%;
    left: 50%; */
    transform: translate(-50%, -50%) scale(0.8);
}

.percentage-text {
    animation: blink 6s linear infinite 0s;
}

.usage-text {
    animation: blink 6s linear infinite 3s;
}

@keyframes blink {
    0% {
        opacity: 0;
        transform: scale(0.8);
    }

    10% {
        opacity: 1;
        transform: scale(1);
    }

    40% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0;
        transform: scale(0.8);
    }

    100% {
        opacity: 0;
        transform: scale(0.8);
    }
}

.usage-unit {
    font-size: 0.8em;
    opacity: 0.8;
    margin-left: 4px;
}

.safari-style-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
}

.safari-button {
    position: relative;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.safari-button:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.safari-button input[type="radio"] {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.safari-button.red {
    background: linear-gradient(135deg, #ff5f57 0%, #ff4444 100%);
}

.safari-button.yellow {
    background: linear-gradient(135deg, #ffbd2e 0%, #ffb300 100%);
}

.safari-button.green {
    background: linear-gradient(135deg, #28ca42 0%, #4caf50 100%);
}

.safari-button input[type="radio"]:checked+.button-dot {
    opacity: 1;
}

.button-dot {
    width: 4px;
    height: 4px;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.safari-button input[type="radio"]:checked {
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3);
}

.safari-button input[type="radio"]:checked+.button-dot {
    opacity: 1;
}

/* 개요형 태블릿 가로: 카드·타이틀 밀도 */
.xeGoalUsageChart.is-overview-compact .goal-chart-title {
    font-size: 10px;
    line-height: 10px;
}

.xeGoalUsageChart.is-overview-compact .goal-card {
    border-radius: 10px;
    padding: 6px 8px;
    border-top-width: 3px;
    min-height: 0;
    height: 100%;
    overflow: hidden;
}

.xeGoalUsageChart.is-overview-compact .card-title {
    font-size: 10px;
    margin-bottom: 4px;
}

.xeGoalUsageChart.is-overview-compact .card-value {
    overflow: hidden;
    z-index: 1;
    min-height: 28px;
    height: auto;
    margin-bottom: 4px;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.xeGoalUsageChart.is-overview-compact .percentage-text {
    font-size: 14px;
    line-height: 1.2;
}

.xeGoalUsageChart.is-overview-compact .goal-status-text {
    font-size: 9px;
    display: inline;
    position: static;
}

.xeGoalUsageChart.is-overview-compact .usage-text {
    font-size: 9px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.xeGoalUsageChart.is-overview-compact .dropping-texts {
    padding: 4px 6px;
    width: 100%;
}

.xeGoalUsageChart.is-overview-compact .card-info {
    padding: 4px;
    overflow: hidden;
}

.xeGoalUsageChart.is-overview-compact .info-row {
    font-size: 10px;
    margin-bottom: 2px;
}

.xeGoalUsageChart.is-overview-compact .goal-usage-value {
    font-size: 15px;
}

.xeGoalUsageChart.is-overview-compact .goal-usage-title,
.xeGoalUsageChart.is-overview-compact .goal-usage-title-small,
.xeGoalUsageChart.is-overview-compact .goal-usage-value-small {
    font-size: 10px;
    line-height: 10px;
}

.xeGoalUsageChart.is-overview-compact .goal-usage-sub {
    margin-bottom: 2px;
}

.xeGoalUsageChart.is-overview-compact .goal-card-container {
    min-height: 0;
    overflow: hidden;
}
</style>
